@if (imageUrl(); as imageUrl) {
    <div class="preview-container" (click)="openLightbox()">
        <img [src]="imageUrl" alt="Label Preview" />
    </div>
    <div class="action-buttons">
        <button class="action-btn" (click)="openLightbox()">
            <pf-icon size="sm" iconType="view"></pf-icon>
            View Larger
        </button>
        <button class="action-btn" (click)="downloadImage()">
            <pf-icon size="sm" iconType="download"></pf-icon>
            Download PNG
        </button>
    </div>
} @else {
    @if (error()) {
        <p>Error rendering preview:</p>
        <pre>{{ error() }}</pre>
    } @else {
        <p>Rendering Label...</p>
    }
}

@if (lightboxOpen() && imageUrl(); as imageUrl) {
    <div class="lightbox-overlay" (click)="closeLightbox()">
        <div class="lightbox-content" (click)="$event.stopPropagation()">
            <img [src]="imageUrl" alt="Label Preview" />
            <div class="lightbox-actions">
                <button class="action-btn" (click)="downloadImage()">
                    <pf-icon size="sm" iconType="download"></pf-icon>
                    Download PNG
                </button>
                <button class="action-btn" (click)="closeLightbox()">
                    <pf-icon size="sm" iconType="close"></pf-icon>
                    Close
                </button>
            </div>
        </div>
    </div>
}
